import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AmplitudeAbstractService } from './amplitude/amplitude.abstract.service';
import { APP_CONFIG, IAppConfig } from './app.config';
import { StorageService } from './storage.service';

declare let ga: Function;
// declare var firebase: any;

export enum AnalyticsEvents {
  // Home Page
  homeDestinationMapCardSeeMore = 'home_destination_map_card_see_more_clicked',
  homeMapPin = 'home_map_pin_clicked',
  homeDestinationCard = 'home_destination_card_clicked',
  homeLoadMoreDestinations = 'home_load_more_destinations_clicked',
  homeLearnMore = 'home_learn_more_clicked',
  homeLoginForBusiness = 'home_login_for_business_clicked',
  homeAppStoreDownload = 'home_app_store_download_clicked',
  homePP = 'home_pp_clicked',
  homeToS = 'home_tos_clicked',
  // Destination Page
  destinationCategoryButtonEvents = 'destination_category_button_events_clicked',
  destinationCategoryButtonGuides = 'destination_category_button_guides_clicked',
  destinationCategoryButtonCollection = 'destination_category_button_collection_clicked',
  destinationCategoryButtonAllPlaces = 'destination_category_button_all_places_clicked',
  destinationGuideCard = 'destination_guide_card_clicked',
  destinationSeeAllGuides = 'destination_see_all_guides_clicked',
  destinationSeeAllCollectionPlaces = 'destination_see_all_collection_places_clicked',
  destinationPlaceCardInCollection = 'destination_place_card_in_collection_clicked',
  destinationPlaceTripPlans = 'destination_place_trip_plans_clicked',
  destinationSeeAllActivitiesAndDeals = 'destination_see_all_activities_and_deals_clicked',
  destinationMapPin = 'destination_map_pin_clicked',
  // Place Page
  placeActionButtonCall = 'place_action_button_call_clicked',
  placeActionButtonDirection = 'place_action_button_direction_clicked',
  placeActionButtonCustom = 'place_action_button_custom_clicked',
  placeInfoCardDirection = 'place_info_card_direction_clicked',
  placeInfoCardPhone = 'place_info_card_phone_clicked',
  placeInfoCardWebsite = 'place_info_card_website_clicked',
  placeMapPin = 'place_map_pin_clicked',
  placeBackButton = 'place_back_button_clicked',
  placeActionButtonClicked = 'place_action_button_clicked',
  // Collection Page
  collectionPlaceCard = 'collection_place_card_clicked',
  collectionPlaceTripPlans = 'collection_place_trip_plans_clicked',
  collectionBackButton = 'collection_back_button_clicked',
  // Events Page
  eventsEventCard = 'events_event_card_clicked',
  eventsMapPin = 'events_map_pin_clicked',
  // Event Popup
  eventBackButton = 'event_back_button_clicked',
  eventAppStoreButton = 'event_app_store_button_clicked',
  eventInfoCardPhone = 'event_info_card_phone_clicked',
  eventInfoCardAddress = 'event_info_card_address_clicked',
  // Guides Page
  guidesGuideCard = 'guides_guide_card_clicked',
  guidesMapPin = 'guides_map_pin_clicked',
  // Guide Page
  guidePlaceCard = 'guide_place_card_clicked',
  guideMapPin = 'guide_map_pin_clicked',
  // Navigation
  navigationLogo = 'navigation_logo_clicked',
  navigationTripPlans = 'navigation_trip_plans_clicked',
  navigationProfile = 'navigation_profile_clicked',
  navigationSearchActivation = 'navigation_search_activation_clicked',
  navigationSearchTyping = 'navigation_search_typing_clicked',
  navigationSearchResultItem = 'navigation_search_result_item_clicked',
  navigationLoginNextButton = 'navigation_login_next_button_clicked',
  navigationLoginFacebook = 'navigation_login_facebook_clicked',
  navigationLoginResendCode = 'navigation_login_resend_code_clicked',
  navigationSignUpNextButton = 'navigation_sign_up_next_button_clicked',
  navigationSignUpFacebook = 'navigation_sign_up_facebook_clicked',
  navigationSignUpResendCode = 'navigation_sign_up_resend_code_clicked',
  // Basic events
  placeView = 'place_view',
  placeAddedToPlans = 'place_added_to_plans',
  placeRemovedFromPlans = 'place_removed_from_plans',
  sessionStart = 'session_start',
  couponView = 'coupon_view',
  eventView = 'event_view',
  passportView = 'passport_view',
}
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly isServer: boolean;

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    @Inject(PLATFORM_ID) private readonly platformId: any,
    private router: Router,
    private storageService: StorageService,
    private amplitudeService: AmplitudeAbstractService,
  ) {
    this.isServer = isPlatformServer(this.platformId);

    if (this.isServer) {
      return;
    }

    this.router.events.subscribe(event => {
      try {
        if (typeof ga === 'function' && event instanceof NavigationEnd) {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
          // console.log('%%% Google Analytics page view event %%%');
        }
      } catch (error) {
        console.log(error);
      }
    });
  }

  /**
   * Emit google analytics event
   */
  public emitEvent(eventName: AnalyticsEvents, parameters: any): void {
    if (this.isServer) {
      return;
    }

    const data = {
      is_registered: this.storageService.TOKEN != null,
      white_label: this.appConfig.settings.config_name,
      ...parameters,
    };
    if (parameters.from && parameters.placeId) {
      this.amplitudeService.setItem('placeId', parameters.placeId);
    } else {
      this.amplitudeService.unsetItem('placeId');
    }
    this.amplitudeService.logEventWithTimestamp(eventName, data);
    // firebase.analytics().logEvent(eventName, parameters);
    // if (typeof ga === 'function') {
    //   ga('send', 'event', parameters);
    //   console.log('Event fly away');
    // }
  }
}
